import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, vModelText as _vModelText, normalizeClass as _normalizeClass, withDirectives as _withDirectives, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "popup__content"
}
const _hoisted_2 = { class: "requisites__block mb-3" }
const _hoisted_3 = { class: "requisites__label requisites__label--start text-capitalize-first" }
const _hoisted_4 = { class: "requisites__content" }
const _hoisted_5 = ["value"]
const _hoisted_6 = { class: "requisites__block mb-3" }
const _hoisted_7 = { class: "requisites__label requisites__label--start text-capitalize-first" }
const _hoisted_8 = { class: "requisites__content" }
const _hoisted_9 = ["placeholder"]
const _hoisted_10 = { class: "popup__controls" }
const _hoisted_11 = { class: "text-capitalize-first" }
const _hoisted_12 = { class: "text-capitalize-first" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_FormInputWrapper = _resolveComponent("FormInputWrapper")!
  const _component_LoaderButton = _resolveComponent("LoaderButton")!
  const _component_Popup = _resolveComponent("Popup")!

  return (_openBlock(), _createBlock(_component_Popup, {
    ref: (el) => _ctx.popup = el,
    title: _ctx.$t('fraudex.leave_feedback'),
    class: "popup__md",
    onOnClose: _ctx.hide
  }, {
    default: _withCtx(() => [
      _createElementVNode("form", null, [
        (_ctx.requisite)
          ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
              _createElementVNode("div", _hoisted_2, [
                _createElementVNode("div", _hoisted_3, _toDisplayString(_ctx.$t('labels.requisites')), 1),
                _createElementVNode("div", _hoisted_4, [
                  _createElementVNode("input", {
                    type: "text",
                    class: "form-control",
                    value: _ctx.requisite,
                    readonly: ""
                  }, null, 8, _hoisted_5)
                ])
              ]),
              _createElementVNode("div", _hoisted_6, [
                _createElementVNode("div", _hoisted_7, _toDisplayString(_ctx.$t('fraudex.comment')), 1),
                _createElementVNode("div", _hoisted_8, [
                  _createVNode(_component_FormInputWrapper, {
                    field: "text",
                    form: "fraudexFeedback"
                  }, {
                    default: _withCtx((parentProps) => [
                      _withDirectives(_createElementVNode("textarea", {
                        class: _normalizeClass(["form-control", parentProps.class]),
                        rows: "4",
                        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.feedbackText) = $event)),
                        placeholder: _ctx.$t('fraudex.comment_placeholder')
                      }, null, 10, _hoisted_9), [
                        [_vModelText, _ctx.feedbackText]
                      ])
                    ]),
                    _: 1
                  })
                ])
              ])
            ]))
          : _createCommentVNode("", true)
      ]),
      _createElementVNode("div", _hoisted_10, [
        _createElementVNode("button", {
          type: "button",
          onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.hide && _ctx.hide(...args))),
          class: "btn popup__close"
        }, [
          _createElementVNode("span", _hoisted_11, _toDisplayString(_ctx.$t('button.cancel')), 1)
        ]),
        _createVNode(_component_LoaderButton, {
          "on-click": _ctx.handleSubmit,
          disabled: !_ctx.feedbackText || _ctx.feedbackText.trim().length === 0,
          class: "btn btn--accept"
        }, {
          default: _withCtx(() => [
            _cache[2] || (_cache[2] = _createElementVNode("i", { class: "fa fa-paper-plane me-2" }, null, -1)),
            _createElementVNode("span", _hoisted_12, _toDisplayString(_ctx.$t('button.send')), 1)
          ]),
          _: 1,
          __: [2]
        }, 8, ["on-click", "disabled"])
      ])
    ]),
    _: 1
  }, 8, ["title", "onOnClose"]))
}